<!-- 限时特卖活动弹窗模板1 -->
<template>
    <div class="popup"  v-if="timeSaleShow" id="timeSaledPopup">
        <div class="timesale-content" :class="'saled-bg-'+lang" id='timeSaled' name='timeSaledPopup' v-show="contentShow" :style="'transform: scale('+screenWidthRatio+');'">
            <!-- <img class="temp" src="../../../assets/images/"> -->
            <div class="timesale-top-close">
                <div style="float:center" class="discount_close" @click="closePage()">
                </div>
            </div>
            <div class="discount_close-bg"></div>
            <div class="timesale-body">
                <div class="timesale-schemes">
                    <div class="timesale-scheme">
                        <div class="timesale-scheme-title">
                            <div>{{"- "+$t('language.paySystem.limitedData')+" -"}}</div>
                         </div>
                        <div class="timesale-scheme-body" v-if="!user.vip" :style="getHeight()">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[0].title,266)">-{{schemes[0].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[0].title}}</div>
                                <div class="scheme-price">
                                    <span class="price">
                                        <span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>
                                        {{schemes[0].price[priceLang]}}
                                        <span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span>
                                    </span>
                                    <span class="price-old">{{schemes[0].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[0].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(0,schemes[0])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[0].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[0].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[1].title,266)">-{{schemes[1].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[1].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[1].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[1].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[1].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(1,schemes[1])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{schemes[1].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[1].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timesale-scheme-body" v-if="user.vip" :style="getHeight()">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[1].title,266)">-{{schemes[1].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[1].title}}</div>
                                <div class="scheme-price">
                                    <span class="price">
                                        <span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>
                                        {{schemes[1].price[priceLang]}}
                                        <span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span>
                                    </span>
                                    <span class="price-old">{{schemes[1].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[1].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(1,schemes[1])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[1].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[1].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[11].title,266)">-{{schemes[11].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[11].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[11].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[11].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[11].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(11,schemes[11])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{schemes[11].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[11].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                         <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-upgrade-tips"><span v-if="user.vip&&nowSchemeName">{{$t('language.paySystem.vipUpgradeTips',{'type':$t(nowSchemeName)})}}</span></div>
                    </div>
                    <div class="timesale-scheme timesale-scheme-un">
                        <div class="timesale-scheme-title">
                            <div>{{"- "+$t('language.paySystem.unlimitedData')+" -"}}</div>
                        </div>
                        <div class="timesale-scheme-body">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[2].title,266)">-{{schemes[2].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[2].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[2].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[2].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[2].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(2,schemes[2])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[2].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[2].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[3].title,266)">-{{schemes[3].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[3].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[3].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[3].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[3].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(3,schemes[3])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[3].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[3].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-upgrade-tips"><span v-if="user.vip&&nowSchemeName">{{$t('language.paySystem.vipUpgradeTips',{'type':$t(nowSchemeName)})}}</span></div>
                    </div>
                </div>
            </div>
            <div class="timesale-footer">
                {{$t('language.'+flashSaledName+'.bottomTip')}}
            </div>
        </div>
        <div class="timesale-content" :class="'saled-bg-'+lang" id="timeLimitedSaled"  name='timeSaledPopup' v-show="contentYearyShow" :style="'transform: scale('+screenWidthRatio+');'">
            <!-- <img class="temp" src="../../../assets/images/"> -->
            <div class="timesale-top-close">
                <div style="float:center" class="discount_close" @click="closePage()"></div>
            </div>
            <div class="discount_close-bg"></div>
            <div class="timesale-body">
                <div class="timesale-schemes" style="justify-content: center;">
                    <div class="timesale-scheme timesale-scheme-un">
                        <div class="timesale-scheme-title">
                            <div>{{"- "+$t('language.paySystem.unlimitedData')+" -"}}</div>
                        </div>
                        <div class="timesale-scheme-body" v-if="yearType==0" :style="getHeight()">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[4].title,338)">-{{schemes[4].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[4].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[4].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[4].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[4].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(4,schemes[4])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[4].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[4].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[5].title,338)">-{{schemes[5].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[5].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[5].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[5].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[5].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(5,schemes[5])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[5].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[5].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timesale-scheme-body" v-if="yearType==1" :style="getHeight()">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[6].title,338)">-{{schemes[6].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[6].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[6].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[6].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[6].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(6,schemes[6])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[6].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[6].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[7].title,338)">-{{schemes[7].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[7].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[7].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[7].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[7].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(7,schemes[7])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[7].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[7].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="timesale-scheme-body" v-if="yearType==2" :style="getHeight()">
                            <div class="timesale-scheme-left">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[8].title,338)">-{{schemes[8].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[8].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[8].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[8].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[8].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(8,schemes[8])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[8].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[8].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="timesale-scheme-line"></div>
                            <div class="timesale-scheme-right">
                                <div class="scheme-discount" :style="getDiscountLeft(schemes[9].title,338)">-{{schemes[9].discount}}<span>%</span></div>
                                <div class="scheme-title">{{schemes[9].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[9].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[9].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[9].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(9,schemes[9])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[9].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[9].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-upgrade-tips"><span v-if="user.vip&&nowSchemeName">{{$t('language.paySystem.vipUpgradeTips',{'type':$t(nowSchemeName)})}}</span></div>
                    </div>
                </div>
            </div>
            <div class="timesale-footer">
                {{$t('language.'+flashSaledName+'.bottomTip')}}
            </div>
        </div>
        <div class="timesale-content" :class="'saled-bg-'+lang" id="timeLimitedSaled"  name='timeSaledPopup' v-show="contentUnlimiedActiveShow" :style="'transform: scale('+screenWidthRatio+');'">
            <!-- <img class="temp" src="../../../assets/images/"> -->
            <div class="timesale-top-close">
                <div style="float:center" class="discount_close" @click="closePage()"></div>
            </div>
            <div class="discount_close-bg"></div>
            <div class="timesale-body">
                <div class="timesale-schemes" style="justify-content: center;">
                    <div class="timesale-scheme timesale-scheme-un" style="width:480px;margin: 23px 0 0 0;">
                        <div class="timesale-scheme-title">
                            <div>{{"- "+$t('language.paySystem.unlimitedData')+" -"}}</div>
                        </div>
                        <div class="timesale-scheme-body">
                            <div class="timesale-scheme-right" style="width:100%">
                                <div class="scheme-discount"  :style="getDiscountLeft(schemes[10].title,480)">-{{schemes[10].discount}}<span>%</span></div>
                                <!-- <div class="scheme-discount"  style="left:30px;">-{{schemes[10].discount}}<span>%</span></div> -->
                                <div class="scheme-title">{{schemes[10].title}}</div>
                                <div class="scheme-price">
                                    <span class="price"><span v-if="currency[priceLang].front">{{currency[priceLang].front}}</span>{{schemes[10].price[priceLang]}}<span v-if="currency[priceLang].after">{{currency[priceLang].after}}</span></span>
                                    <span class="price-old">{{schemes[10].oldPrice[priceLang]}}</span>
                                </div>
                                <div class="scheme-type">{{schemes[10].type}}</div>
                                <div class="scheme-btn">
                                    <button @click="openPage(10,schemes[10])">{{$t('language.popup.worldBackupPopup.getOffer')}}</button>
                                </div>
                                <div class="scheme-tips">
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{schemes[10].tip}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{schemes[10].tipPs}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips1')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps1')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="scheme-tip">
                                        <div class="point"></div>
                                        <span>{{$t('language.popup.worldBackupPopup.tips2')}}
                                            <div class="ask">
                                                <div class="plan-questionTxt">{{$t('language.popup.worldBackupPopup.ps2')}}</div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-upgrade-tips"><span v-if="user.vip&&nowSchemeName">{{$t('language.paySystem.vipUpgradeTips',{'type':$t(nowSchemeName)})}}</span></div>
                    </div>
                </div>
            </div>
            <div class="timesale-footer">
                {{$t('language.'+flashSaledName+'.bottomTip')}}
            </div>
        </div>
        <!-- <div class="timelimited-content" id="timeLimitedSaled"  v-show="contentUnlimiedShow">
            <div style="width:100%;height:45Px;line-height:45Px;font-size:18Px;font-family:'Sans Serif';color:#8c8c8c;background-color:;">
                <div style="float:left" class=""></div>
                <div style="float:left;font-size:16Px;word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:70%;font-weight:bold;padding-left:10Px"
                    class="null"></div>
                <div style="float:right" class="discount_close" @click="closePageTwo()"></div>
                </div>
                <div style="width:100%;height:460Px;">
                    <div class="mainPart">
                    <div class="main_title">
                        <h6>{{$t('language.popup.salePagePopup.sOffer')}}</h6>
                        <div>{{$t('language.popup.salePagePopup.timeLimited')}}</div>
                    </div>
                    <div class="c-top-right">
                        <div id="remainTime">
                                <span>{{firstHour}}</span>
                                <span>{{secondHour}}</span>
                                <div>:</div>
                                <span>{{firstMinute}}</span>
                                <span>{{secondMinute}}</span>
                                <div>:</div>
                                <span>{{firstSeconds}}</span>
                                <span>{{secSeconds}}</span>
                            </div>

                    <div class="c-top-right right-dis">
                            <div class="timer-describe-old"><span>{{$t('language.popup.salePagePopup.Hours')}}</span><span>{{$t('language.popup.salePagePopup.Minutes')}}</span><span>{{$t('language.popup.salePagePopup.Seconds')}}</span></div>
                    </div>
                    <div class="c-right-footer">
                        <div class="c-price-describe">
                            <span style="color:#FC683C;font-weight: 600;">{{timeMonthData.price[priceLang]}}</span>
                                {{$t('language.popup.salePagePopup.dataTra')}}
                        </div>
                        <button class="c-top-btn c-unlimit-btn" type="button" style="float:none;" @click="buyUnlimited()">{{$t('language.popup.salePagePopup.subscribe')}}</button>
                    </div>
                    </div>
                    <div class="msgContent special-msgContent" :style="{height:getHeight()}">
                        <el-scrollbar style="height:100%">
                            <table class="upgrade-table special-table" :style="{lineHeight:getlineHeight()}">
                                <tbody>
                                    <tr style="border:0Px;font-weight: 600;">
                                        <td class="no_style">{{$t('language.popup.salePagePopup.features')}}</td>
                                        <td>{{$t('language.popup.salePagePopup.freePlan')}}</td>
                                        <td>{{$t('language.paySystem.specialOffer')}}</td>
                                    </tr>
                                    <tr v-for="(lItem, lIndex) in limitedExplanData" :key="lIndex" :class="lItem.more?'explain-tip':''">
                                        <td  v-if="!lItem.more" :class="lItem.more?'':'no_style'" >{{lItem.feature}}
                                            <img src="../../../assets/images/workspace/jiantou.png"
                                                class="explain" v-if="lIndex&&lItem.desShow" @click="showMore(lItem,lIndex)">
                                            <img src="../../../assets/images/workspace/jiantou2.png"
                                                class="explain" v-if="lIndex&&!lItem.desShow" @click="showMore(lItem,lIndex)">
                                        </td>
                                        <td v-if="lItem.freePlan&&!lItem.more">{{lItem.freePlan}}</td>
                                        <td v-if="!lItem.freePlan&&!lItem.more"><img src="../../../assets/images/workspace/wrong.png"></td>
                                        <td v-if="lItem.specialOffer&&!lItem.more">{{lItem.specialOffer}}</td>
                                        <td v-if="!lItem.specialOffer&&!lItem.more"><img src="../../../assets/images/workspace/gou.png"></td>
                                        <td style="max-width:180Px;font-size:12Px;" v-cloak  v-if="lItem.more">{{lItem.des}}</td>
                                        <td v-if="lItem.more" colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
        </div> -->
        <iosPayTipDialog ref="iosPayTipDialog"></iosPayTipDialog>
    </div>
</template>

<script>
import upgradeItemUtils from '@/js/workspace/upgrade_item.js';
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import googleAnalyticsUtil from "../../../js/workspace/google_analytics_util.js";
import paySysUtils from "@/js/workspace/pay_system_util.js";
import flip from '@/components/common/flip/flip';
import iosPayTipDialog from '@/components/popup/pay_system_popups/ios_pay_tip_popups';//用户当前套餐信息弹窗
export default {
    data: function() {
        return {
            flashSaledName: commonstate.flashSaledName,
            askShow:false,
            timeSaleShow:false,
            contentShow:false,
            contentUnlimiedShow: false,
            contentUnlimiedActiveShow: false,
            contentYearyShow: false,
            user: commonUtils.getUser(),
            priceLang: commonUtils.getPriceForLange(localStorage.getItem("locale")),
            endTime:99999999999,//99999999999,
            yearType: 0,//是否是年一
            lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
            firstHour:0,
            secondHour:0,
            firstMinute:0,
            secondMinute:0,
            firstSeconds:0,
            secSeconds:0,
            t:null,
            requestNum:0,
            leftTime:86400000,
            currency: {
                "USD": {
                    "front": "$"
                },
                "ECU": {
                    "after": " €",
                },
                "BRL": {
                    "front": "R$ "
                },
                "JPY": {
                    "after": "円",
                },
                "TWD": {
                    "front": "NT$"
                },
                "CNY": {
                    "front": "¥ "
                },
            },
            screenWidth: null,//屏幕宽度
            screenWidthRatio: 1,//屏幕宽度比值
            nowSchemeName: null, //用户当前套餐名
        }
    },
    mounted () {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => { 
            return (() => {
            this.screenWidth = document.body.clientWidth;
            })()
        };
        if(this.user.vip) {
            //付费用户获取套餐名
            this.getVipNowSchemes();
        }
    },
    components: {
        flip,
        iosPayTipDialog,
    },
    computed:{
        schemes: function(){ 
            return [{
                        title: this.$t('language.paySystem.arguments.title.monthly100GB'),
                        productId: "241015",
                        coupon: "1N7-RVK-GLJ",
                        discount: "20",
                        price: {
                            "USD":"7.99",
                            "ECU":"7,99",
                            "BRL":"41",
                            "JPY":"944",
                            "TWD":"229",
                            "CNY":"51",
                            },
                        oldPrice: {
                            "USD":"$9.99",
                            "ECU":"9,99 €",
                            "BRL":"R$ 51",
                            "JPY":"1,180円",
                            "TWD":"NT$286",
                            "CNY":"¥ 64",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perMonth'),
                        tip: this.$t('language.popup.worldBackupPopup.tips100Mo'),
                        tipPs: this.$t('language.popup.worldBackupPopup.ps100Mo'),
                        xMb: 14,
                        xLevel: 2,
                        xPage: this.flashSaledName+"-2025-sale-monthly1-popup",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.yearly1200GB'),
                        productId: "241023",
                        coupon: "KUE-8KP-9BM",
                        discount: "58",
                        price: {
                            "USD":"49.99",
                            "ECU":"49,99",
                            "BRL":"255",
                            "JPY":"5,905",
                            "TWD":"1,431",
                            "CNY":"320",
                            },
                        oldPrice: {
                            "USD":"$119.88",
                            "ECU":"119,88 €",
                            "BRL":"R$ 612",
                            "JPY":"14,160円",
                            "TWD":"NT$3,432",
                            "CNY":"¥ 768",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tips1200Yr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.ps1200Yr'),
                        xMb: 30,
                        xLevel: 2,
                        xPage: this.flashSaledName+"-2025-sale-annual1-popup",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.yearlyUnlimit'),
                        productId: "241024",
                        coupon: "TNM-Y75-NNK",
                        discount: "67",
                        price: {
                            "USD":"99",
                            "ECU":"99",
                            "BRL":"507",
                            "JPY":"11,689",
                            "TWD":"2,832",
                            "CNY":"632",
                            },
                        oldPrice: {
                            "USD":"$299",
                            "ECU":"299 €",
                            "BRL":"R$ 1,532",
                            "JPY":"35,305円",
                            "TWD":"NT$8,554",
                            "CNY":"¥ 1,908",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnYr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnYr'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-annualun-popup",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.lifetimeUnlimit'),
                        productId: "241025",
                        coupon: "5ZV-6YW-SBM",
                        discount: "70",
                        price: {
                            "USD":"189",
                            "ECU":"189",
                            "BRL":"968",
                            "JPY":"22,320",
                            "TWD":"5,408",
                            "CNY":"1,206",
                            },
                        oldPrice: {
                            "USD":"$628",
                            "ECU":"628 €",
                            "BRL":"R$ 3,217",
                            "JPY":"74,153円",
                            "TWD":"NT$17,967",
                            "CNY":"¥ 4,007",
                            },
                        type: this.$t('language.paySystem.Onetime'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnLi'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnLi'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-lifetimeun-popup",
                    },
                    //年以下付费
                    {
                        title: this.$t('language.paySystem.arguments.title.yearlyUnlimit'),
                        productId: "241024",
                        coupon: "TNM-Y75-NNK",
                        discount: "67",
                        price: {
                            "USD":"99",
                            "ECU":"99",
                            "BRL":"507",
                            "JPY":"11,689",
                            "TWD":"2,832",
                            "CNY":"632",
                            },
                        oldPrice: {
                            "USD":"$299",
                            "ECU":"299 €",
                            "BRL":"R$ 1,532",
                            "JPY":"35,305円",
                            "TWD":"NT$8,554",
                            "CNY":"¥ 1,908",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnYr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnYr'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-annualun-promotion",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.lifetimeUnlimit'),
                        productId: "241025",
                        coupon: "5ZV-6YW-SBM",
                        discount: "70",
                        price: {
                            "USD":"189",
                            "ECU":"189",
                            "BRL":"968",
                            "JPY":"22,320",
                            "TWD":"5,408",
                            "CNY":"1,206",
                            },
                        oldPrice: {
                            "USD":"$628",
                            "ECU":"628 €",
                            "BRL":"R$ 3,217",
                            "JPY":"74,153円",
                            "TWD":"NT$17,967",
                            "CNY":"¥ 4,007",
                            },
                        type: this.$t('language.paySystem.Onetime'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnLi'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnLi'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-lifetimeun-promotion",
                    },
                    //年一
                    {
                        title: this.$t('language.paySystem.arguments.title.yearlyUnlimit'),
                        productId: "240899",
                        coupon: "9XL-DRB-AZC",
                        discount: "80",
                        price: {
                            "USD":"59",
                            "ECU":"59",
                            "BRL":"302",
                            "JPY":"6,966",
                            "TWD":"1,688",
                            "CNY":"376",
                            },
                        oldPrice: {
                            "USD":"$299",
                            "ECU":"299 €",
                            "BRL":"R$ 1,532",
                            "JPY":"35,305円",
                            "TWD":"NT$8,554",
                            "CNY":"¥ 1,908",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnYr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnYr'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-annualun-upgrade",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.lifetimeUnlimit'),
                        productId: "240901",
                        coupon: "PJW-L1D-CS3",
                        discount: "80",
                        price: {
                            "USD":"129",
                            "ECU":"129",
                            "BRL":"611",
                            "JPY":"15,231",
                            "TWD":"3,690",
                            "CNY":"823",
                            },
                        oldPrice: {
                            "USD":"$628",
                            "ECU":"628 €",
                            "BRL":"R$ 3,217",
                            "JPY":"74,153円",
                            "TWD":"NT$17,967",
                            "CNY":"¥ 4,007",
                            },
                        type: this.$t('language.paySystem.Onetime'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnLi'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnLi'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-lifetimeun-upgrade",
                    },
                    //其他非无限年
                    {
                        title: this.$t('language.paySystem.arguments.title.yearlyUnlimit'),
                        productId: "240902",
                        coupon: "HXT-XXN-Z1Z",
                        discount: "94",
                        price: {
                            "USD":"19",
                            "ECU":"19",
                            "BRL":"97",
                            "JPY":"2,242",
                            "TWD":"543",
                            "CNY":"121",
                            },
                        oldPrice: {
                            "USD":"$299",
                            "ECU":"299 €",
                            "BRL":"R$ 1,532",
                            "JPY":"35,305円",
                            "TWD":"NT$8,554",
                            "CNY":"¥ 1,908",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnYr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnYr'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-annualun-upgrade",
                    },
                    {
                        title: this.$t('language.paySystem.arguments.title.lifetimeUnlimit'),
                        productId: "240904",
                        coupon: "WW4-E1L-YWY",
                        discount: "86",
                        price: {
                            "USD":"89",
                            "ECU":"89",
                            "BRL":"456",
                            "JPY":"10,507",
                            "TWD":"2,546",
                            "CNY":"568",
                            },
                        oldPrice: {
                            "USD":"$628",
                            "ECU":"628 €",
                            "BRL":"R$ 3,217",
                            "JPY":"74,153円",
                            "TWD":"NT$17,967",
                            "CNY":"¥ 4,007",
                            },
                        type: this.$t('language.paySystem.Onetime'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnLi'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnLi'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-lifetimeun-upgrade",
                    },
                    //无限
                    {
                        title: this.$t('language.paySystem.arguments.title.lifetimeUnlimit'),
                        productId: "240905",
                        coupon: "QB4-J3Y-THZ",
                        discount: "90",
                        price: {
                            "USD":"69",
                            "ECU":"69 ",
                            "BRL":"354",
                            "JPY":"8,149",
                            "TWD":"1,975",
                            "CNY":"440",
                            },
                        oldPrice: {
                            "USD":"$628",
                            "ECU":"628 €",
                            "BRL":"R$ 3,217",
                            "JPY":"74,153円",
                            "TWD":"NT$17,967",
                            "CNY":"¥ 4,007",
                            },
                        type: this.$t('language.paySystem.Onetime'),
                        tip: this.$t('language.popup.worldBackupPopup.tipsUnLi'),
                        tipPs: this.$t('language.popup.worldBackupPopup.psUnLi'),
                        xMb: 30,
                        xLevel: 1,
                        xPage: this.flashSaledName+"-2025-sale-lifetimeun-upgrade",
                    },
                    //giveAway活动用户
                    {
                        title: this.$t('language.paySystem.arguments.title.yearly2400GB'),
                        productId: "240887",
                        coupon: "E6Y-EBP-ZZC",
                        discount: "58",
                        price: {
                            "USD":"99.98",
                            "ECU":"99,98",
                            "BRL":"510",
                            "JPY":"11,809",
                            "TWD":"2,862",
                            "CNY":"641",
                            },
                        oldPrice: {
                            "USD":"$239.76",
                            "ECU":"239,76 €",
                            "BRL":"R$ 1,224",
                            "JPY":"28,320円",
                            "TWD":"NT$6,864",
                            "CNY":"¥ 1,536",
                            },
                        type: this.$t('language.paySystem.tabPayScheme.perYear'),
                        tip: this.$t('language.popup.worldBackupPopup.tips2400Yr'),
                        tipPs: this.$t('language.popup.worldBackupPopup.ps2400Yr'),
                        xMb: 30,
                        xLevel: 2,
                        xPage: "",
                    },
                ]
        },
        timeMonthData:function () {
            return {
                    planName:this.$t('language.paySystem.monthlyUnlimited'),
                    price: {
                        "USD":"$24.99",
                        "ECU":"24,99 €",
                        "BRL":"R$ 128",
                        "JPY":"2,956円",
                        "TWD":"NT$713",
                        "CNY":"¥ 159",
                        },
                    productId:'241029',
                    coupon: 'K6S-5DR-2T6',
                    xMb:14,//退款天数
                    xPage:'monthlyun72-popup',
                    payLevel:1,
                    xLevel: 1,
                }
        },
        limitedExplanData:function () {
            return [
                {
                   feature:this.$t('language.popup.salePagePopup.moreData'),
                   freePlan:this.$t('language.popup.upgradeAccountPopup.monthTraffic'),
                   specialOffer:'★'+this.$t('language.popup.salePagePopup.unlimitedData'),
                },{
                    feature:this.$t('language.popup.salePagePopup.syncModes'),
                   freePlan:'2',
                   specialOffer:'8',
                   des:this.$t('language.popup.salePagePopup.syncModesDes'),
                   desShow:true,
                },{
                    feature:this.$t('language.popup.salePagePopup.scheduledTran'),
                    freePlan:null,
                    specialOffer:null,
                    des:this.$t('language.popup.salePagePopup.scheduledTranDes'),
                    desShow:true,
                },{
                   feature:this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
                   freePlan:null,
                   specialOffer:null,
                   des:this.$t('language.popup.salePagePopup.transferSpeedDes'),
                   desShow:true,
                },{
                   feature:this.$t('language.popup.upgradeAccountPopup.doubledSync'),
                   freePlan:null,
                   specialOffer:null,
                   des:this.$t('language.popup.upgradeAccountPopup.sameTime'),
                   desShow:true,
                },{
                   feature:this.$t('language.popup.upgradeAccountPopup.filter'),
                   freePlan:null,
                   specialOffer:null,
                   des:this.$t('language.popup.upgradeAccountPopup.automatically'),
                   desShow:true,
                },
            ]
        },
    },
    watch:{
        timeSaleShow(newValue,oldValue){
            if(!this.contentUnlimiedShow){
                return;
            }
            if(newValue){
                let that=this;
                that.$nextTick(()=>{
                    //获取当前时间
                    that.$i18n.locale = localStorage.getItem("locale") || 'english';
                    that.$forceUpdate();
                    that.getTimeAllData();
                    var date = new Date();
                    that.user=commonUtils.getUser();
                    var loginTime = that.user.loginTime;
                    var login72Time = that.user.login72Time;
                    //设置截止时间
                    var end;
                    if(that.contentShow){
                        end= loginTime+86400000;
                    }else{
                        end= login72Time+86400000;
                    }
                    //时间差
                    var leftTime = end - new Date().getTime();
                    if(leftTime<86400000){
                        this.leftTime=leftTime;
                    }
                    that.countTime();
                });
            }else{
                clearTimeout(this.t);
            }
        },
        screenWidth: {
            handler: function (val, oldVal) {
                let defaultWidth = 1920;
                let screenWidthRatio = ((val-defaultWidth)/defaultWidth/2 + 1).toFixed(2);
                if(screenWidthRatio<0.5) {
                    screenWidthRatio = 0.5;
                }else if(screenWidthRatio>2) {
                    screenWidthRatio = 2;
                }
                this.screenWidthRatio = screenWidthRatio;
            },
        },
    },
    methods:{
        showMore(item,index){
            if(index!=0){
                if(!this.limitedExplanData[index+1] || !this.limitedExplanData[index+1].more ){
                    let newItem={
                        des:item.des,
                        more:true
                    }
                    if(index+1<=this.limitedExplanData.length){
                        this.limitedExplanData.splice(index+1,0,newItem);
                    }else{
                        this.limitedExplanData.push(newItem);
                    }
                    item.desShow=false;
                }else{
                    item.desShow=true;
                    this.limitedExplanData.splice(index+1,1);
                }
            }
        },
        getHeight() {
            // if(this.$i18n.locale == 'spanish'){
            //     return 'min-height: 340Px;'
            // }
        },
        getDiscountLeft(str,width) {
            //固定
            return 'left:10px;'
            //自适应
            // var left = Math.ceil((width-this.calculateWidth(str,16,"Arial")-110)/2)
            // return 'left:'+ left +'px;'
        },
        calculateWidth(str, fontSize, fontFamily) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "bold " + fontSize + "px " + fontFamily;
            var width = context.measureText(str).width;
            return width;
        },
        buyUnlimited(){
            //每次打开界面获取的最新用户信息
            //this.user = commonUtils.getUser();
            var that = this;
            commonUtils.refreshUserInfo(this.$parent,function(res){
                that.user = res;
                if (!commonstate.emailpattern.test(that.user.email)) {
                    //打开绑定邮箱界面
                    paySysUtils.openBindEmailPage(that.$parent.$refs.rightContBan,that.timeMonthData,"openSaleTwo");
                    return false;
                }
                googleAnalyticsUtil.pay2(that, "monthly-un3");
                let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
                var action =commonstate.cbLinkUrl+'/1533/purl-mc-cart?x-linkid='+lang+'';
                let item = that.timeMonthData;
                commonUtils.addShoppingCartRecords(action, item, that.user, 3);
                // commonUtils.packageFormAndSubmit(action,item,that.user);
                that.getUserStatus();
            });
        },
        showPopup(user,time){
            let webType = commonUtils.judgeClient();
            if(webType != "PC"){
                return;
            }
            if(this.$i18n.locale == 'spanish'){
                $(".timesale-scheme-body").addClass("big-timesale-scheme-body");
            }
            //标记已经打开过弹窗
            if(!localStorage.getItem(this.flashSaledName + "SaledClose")){
                localStorage.setItem(this.flashSaledName + "SaledClose",new Date().getTime());
            }
            this.endTime = time;
            this.timeSaleShow = true;
            if(user.vip){
                if((user.userExpandList&&"auth1"==user.userExpandList[0].value)&&commonstate.activeLoginTypeList.includes(user.loginType)&&user.subscrId == user.id){
                    //giveAway活动用户
                    this.contentShow = true;
                    return;
                }
                //年以下用户
                if(user.payType!="Yearly"&&user.payType!="Lifetime"){
                    this.contentYearyShow = true;
                    this.yearType = 0;
                }else if(user.payType=="Yearly"&&user.payLevel>1){
                    //获取用户套餐信息
                    this.contentYearyShow = true;
                    this.Utils.doSubinquiryPostRequest('get_by_user', { ud: this.user.id }).then(res => {
                        if(res.nowScheme){
                            //有等效id使用等效id
                            let vipId = res.nowScheme.equivalentVip?res.nowScheme.equivalentVip:res.nowScheme.id;
                            if(vipId=="2990c54096364a38a0e115f5602385be"){
                                //年1
                                this.yearType = 1;
                            }else{
                                //年2
                                this.yearType = 2;
                            }
                        }
                    });
                }else if(user.payType!="Lifetime"){
                    //无限用户
                    this.contentUnlimiedActiveShow = true;
                }
            }else{
                //免费用户
                this.contentShow = true;
            }
        },
        openPage(index,item) {
            var that = this;
            //限制ios套餐
            if(that.user.vip&&(that.user.subscrId.substr(0,2) == "20" || that.user.subscrId.substr(0,1) == "3")){
                //获取ios用户订阅状态
                that.Utils.doSubinquiryPostRequest('get_state_ios', {
                    ud: that.user.id,
                    salt: that.user.salt
                }).then(response => {
                    if(response[0]&&response[0].autoRenewStatus == 1){
                        that.$refs.iosPayTipDialog.iosPayTipShow = true;
                        that.$refs.iosPayTipDialog.payInfo = {
                            name: item.title,
                            appleId: response[0].originalTransactionId,
                        };
                    }else{
                        that.openPagePay(index,item);
                    }
                })
            }else{
                that.openPagePay(index,item);
            }
        },
        openPagePay(index,item){
            //每次打开界面获取的最新用户信息
            var that = this;
            that.Utils.doUserHaveLoginRequest('getUpShellActiveTime', {
                ud: that.user.id,
                salt: that.user.salt,
                upShellActiveType: this.flashSaledName + "SaledClose",
            }).then(response => {
                if(response.status == 200){
                    var upShellActiveTime = response.upShellActiveTime;
                    //获取当前时间
                    var date = new Date().getTime();
                    if(upShellActiveTime) {
                        upShellActiveTime = response.upShellActiveTime;
                    }else{
                        upShellActiveTime = date+(24*60*60*1000);
                        let changeData = {
                            ud: that.user.id,
                            upShellActiveTime: upShellActiveTime,
                            upShellActiveType: this.flashSaledName + "SaledClose",
                            upShellActiveDayNum: 90,
                        }
                        that.Utils.doUserHaveLoginRequest("saveUpShellActiveTime", changeData).then(res => {
                            //右上角显示
                            that.saleShow = true;
                            //打开活动
                            that.$parent.$refs.limitedSaledDialog.showPopup(commonUtils.getUser());
                        });
                    }
                    if (!commonstate.emailpattern.test(commonUtils.getUser().email)) {
                        that.sendGAEvent(item);
                        //打开绑定邮箱界面
                        item.index=index;
                        paySysUtils.openBindEmailPage(that.$parent.$refs.rightContBan,item,"openSaleOne");
                        return false;
                    }

                    let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
                    
                    //this.user=commonUtils.getUser();
                    //设置截止时间
                    var end= upShellActiveTime;
                    //时间差
                    var leftTime = end-date;
                    if(index == 0){
                        if(leftTime > 0 && !(that.user.userExpandList&&"auth1"==that.user.userExpandList[0].value)){
                            // googleAnalyticsUtil.pay2(that, "monthly1-0-popup");
                            let  downTime=Math.floor(leftTime/1000);
                            let page='monthly3';
                            let pHtml='monthly-unlimited-web.html';
                            let link='/'+pHtml+'?id='+that.user.id+'&time='+downTime+'&lang='+lang+'&page='+ page + '';
                            let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
                            if(language!='en'&&language!='nl'){
                                window.open(commonstate.frontEndUrl+'/'+language + link, '_blank');
                            }else{
                                window.open(commonstate.frontEndUrl + link, '_blank');    
                            }
                        }else{
                            // 取得要提交页面的URL
                            var action =commonstate.cbLinkUrl+'/1533/purl-mc-cart?x-linkid='+lang+'';
                            commonUtils.addShoppingCartRecords(action, item, that.user, 3);
                            // commonUtils.packageFormAndSubmit(action,item,that.user);
                        }
                    }else{
                        that.sendGAEvent(item);
                        // 取得要提交页面的URL
                        var action =commonstate.cbLinkUrl+'/1533/purl-mc-cart?x-linkid='+lang+'';
                        if(that.contentShow&&that.user.vip){
                            //如果是giveAway活动用户
                            var userType = that.user.loginType;
                            if(userType=='a202302'){
                                item.xPage = '2023-CB';
                            }else if((user.userExpandList&&"auth1"==user.userExpandList[0].value)){
                                item.xPage = 'auth1';
                            }else if(commonstate.active500GBList.includes(userType)||commonstate.active200GBList.includes(userType)){
                                item.xPage = '2024-'+userType;
                            }
                        }
                        commonUtils.addShoppingCartRecords(action, item, that.user, 3);
                        // commonUtils.packageFormAndSubmit(action,item,that.user);
                    }
                    that.getUserStatus();
                }
            })
        },
        sendGAEvent(item){
            let that = this;
            if(item.productId == "215655"){
            googleAnalyticsUtil.pay2(that, "monthly1-0");
            }
            if(item.productId == "215656"){
            googleAnalyticsUtil.pay2(that, "quarterly1");
            }
            if(item.productId == "215657"){
            googleAnalyticsUtil.pay2(that, "yearly1");
            }
            if(item.productId == "215658"){
            googleAnalyticsUtil.pay2(that, "yearly-un1");
            }
            if(item.productId == "226093"){
            googleAnalyticsUtil.pay2(that, "life-un1");
            }
        },
        closePage(){
            $(".timesale-top-close").hide();//隐藏关闭按钮

            let that=this;
            //目标div的offset
            var notice = $('#saleImg').offset();
            $("[name='timeSaledPopup']").animate({
                left:notice.left+22,
                top:notice.top+12,
                marginLeft:0,
                marginTop:0,
                height:0,
                width:0
            },1300);

            let t = setTimeout(function () {
                that.timeSaleShow = false;
                that.contentShow = false;
                that.contentUnlimiedShow = false;
                that.contentUnlimiedActiveShow = false;
                that.contentYearyShow = false;
                // if(that.$parent.$refs.rightContBan.letNotificationsShow){
                //         that.$parent.$refs.rightContBan.$refs.notificationsDialog.notificationsShow = true;
                //         that.$parent.$refs.rightContBan.$refs.notificationsDialog.contentShow = true;
                //         that.$parent.$refs.rightContBan.letNotificationsShow =false;
                //         commonUtils.updateViewTime();
                //         return;
                // }
                // if(that.$parent.$refs.rightContBan.letTimeSalePassWordShow){
                //     that.$parent.$refs.rightContBan.letTimeSalePassWordShow = false;
                //     that.$parent.$refs.rightContBan.showPassWord();
                // }
                clearTimeout(t);
            }, 1200);

            //打开悬浮窗口
            if(this.$parent.$refs.freeSaledFloating) {
                this.$parent.$refs.freeSaledFloating.isOpen();
            }
        },
        closePageTwo(){
             var notice = $('#purpleFun').offset();
           for(let i=0;i<this.limitedExplanData.length;i++){
               if(!this.limitedExplanData[i].feature){
                   this.limitedExplanData.splice(i,1);
                   this.limitedExplanData[i-1].desShow=true;
               }else{
                   this.limitedExplanData[i].desShow=true;
               }
           }
           let that=this;
           $('#timeLimitedSaled').animate({
    		left:notice.left+22,
    		top:notice.top+12,
    		marginLeft:0,
    		marginTop:0,
    		height:0,
			width:0
		  },1300);
           let t = setTimeout(function () {
                that.timeSaleShow = false;
                  if(that.$parent.$refs.rightContBan.letNotificationsShow){
                        that.$parent.$refs.rightContBan.$refs.notificationsDialog.notificationsShow = true;
                        that.$parent.$refs.rightContBan.$refs.notificationsDialog.contentShow = true;
                        that.$parent.$refs.rightContBan.letNotificationsShow =false;
                        commonUtils.updateViewTime();
                }
                clearTimeout(t);
            }, 1200);
        },
        countTime(){
            this.leftTime = this.leftTime - 1000;
            let leftTime=this.leftTime;
            let that=this;
            //定义变量 d,h,m,s保存倒计时的时间
            var d,h,m,s;
            if (leftTime>=0) {
                h = Math.floor(leftTime/1000/60/60%24);
                m = Math.floor(leftTime/1000/60%60);
                s = Math.floor(leftTime/1000%60);
              if (h < 10) {
                this.firstHour =0;
                this.secondHour=h;
                }else{
                 h = h + "";
                this.firstHour = h.charAt(0);
                this.secondHour= h.charAt(1);
                }
              if (m < 10) {
                this.firstMinute=0;
                this.secondMinute=m;
               }else{
                m = m + "";
                this.firstMinute=m.charAt(0);
                this.secondMinute=m.charAt(1);
               }
               if (s < 10) {
               this.firstSeconds=0;
               this.secSeconds=s;
               }else{
                s = s + "";
                this.firstSeconds=s.charAt(0);
                this.secSeconds=s.charAt(1);
               }
            //递归每秒调用countTime方法，显示动态时间效果
            this.t= setTimeout(function () {
                that.countTime();
            }, 1000);
            }else{
                this.firstHour=0;
                this.secondHour=0;
                this.firstSeconds=0;
                this.secSeconds=0;
                this.firstMinute=0;
                this.secondMinute=0;
                 setTimeout(function () {
                //如果显示的是第二个弹窗，则隐藏并且隐藏沙漏
                if(that.contentUnlimiedShow){
                    that.timeSaleShow=false;
                    that.contentUnlimiedShow=false;
                    that.$parent.$refs.rightContBan.funnelShow=false;
                }else{
                    that.contentShow=false;
                    that.timeSaleShow=false;
                    that.$parent.$refs.rightContBan.funnelShow=false;
                }
                 },2000);
            }
        },
        getTimeAllData(){
                for (let index = 0; index < this.schemes.length; index++) {
                    const element = this.schemes[index];
                    if(index==0){
                    element.planName = this.$t('language.popup.monthly');
                    element.planTraffic = this.$t('language.popup.salePagePopup.monthGb');
                    }
                    if(index==1){
                        element.planName=this.$t('language.popup.salePagePopup.quarterly');
                        element.planTraffic=this.$t('language.popup.salePagePopup.monthGbly');
                    }
                    if(index==2){
                        element.planName =this.$t('language.popup.salePagePopup.yearly');
                        element.planTraffic=this.$t('language.popup.salePagePopup.monthfourLy');
                    }
                    if(index==3){
                        element.planName=this.$t('language.paySystem.YearlyUnlimited');
                        element.planTraffic=this.$t('language.popup.salePagePopup.unTr');
                    }
                    if(index==4){
                        element.planName =this.$t('language.rightTopBanner.lifeTimePlan');
                        element.planTraffic=this.$t('language.popup.salePagePopup.unTr');
                    }
        
                }
        },
        //72小时用
        getlineHeight(){
            let result;
            if(this.$i18n.locale == 'deutsch'||this.$i18n.locale == 'france'||this.$i18n.locale == 'portuguese'||this.$i18n.locale == 'italian') {
                result = 20+'Px';
            }
            return result;
        },
        //购买套餐后判断用户状态
        getUserStatus(){
            let oldUser=this.user;
            let that=this;
            let newUser;
            let oldPassword;
            let t;
            this.Utils.doUserHaveLoginRequest('get', {
                ud: oldUser.id,
                salt: oldUser.salt
            }).then(response => {
                that.requestNum=that.requestNum+1;
                newUser = response.user;
                if(!oldUser.password){
                delete newUser.password;
                }else{
                oldPassword=oldUser.password;
                }
                that.$store.commit('setPassWord', response.user.password);
                var result =commonUtils.Compare(oldUser, newUser);
                if(that.requestNum==80){//如果请求了80次则取消请求
                    clearTimeout(t);
                    return false;
                }
                if(result!=false){//如果结果是相等则过4秒再进行请求
                t=setTimeout(()=>{
                    that.getUserStatus();
                },2500);
                }else{//如果用户状态已改变
                    clearTimeout(t);
                    if(oldPassword){
                        newUser.password=oldPassword;
                    }else{
                        delete newUser.password;
                    }
                    localStorage.setItem("user", JSON.stringify(newUser));
                    that.$cookies.set("user",JSON.stringify(newUser));
                    that.user = newUser;
                    that.$store.commit("setUpdateUserSchems", true);
                    if(newUser.vip){
                        localStorage.removeItem("newPayMoney");
                        that.$parent.$refs.rightContBan.user = newUser;
                        that.$parent.$refs.rightContBan.email=newUser.email;
                        that.$parent.$refs.rightContBan.usedTraffic = newUser.usedBy
                        that.$parent.$refs.rightContBan.totalTraffic = newUser.totalBytes;
                        commonUtils.createPayBtn(newUser, that.$parent.$refs.rightContBan);
                    }
                    if (newUser.payLevel <=1) {
                        if (newUser.payType == 'Lifetime') {
                            that.$parent.$refs.rightContBan.saleShow = false;
                        }
                    }
                    that.closePage();
                }
            });
        },
        getVipNowSchemes() {
            let paySysRes = this.$store.getters.getPaySysRes;
            if(paySysRes!=null&&!this.nowScheme){
                //本页面未加载过时加载
                if(paySysRes.nowScheme!={}&&paySysRes.nowScheme!=null&&paySysRes.nowScheme.id){
                    //如果非免费用户
                    this.setNowScheme(paySysRes);
                }
            }
            var that = this;
            this.Utils.doSubinquiryPostRequest('get_by_user', { ud: this.user.id }).then(res => {
                //如果请求成功
                that.setNowScheme(res);
                //缓存信息
                that.$store.commit("setPaySysRes", res);
            });
        },
        setNowScheme(res){
            if (res.message == 'success' && res.vipSchemes && this.user.vip) {
                if(res.nowScheme.attrib == 0){
                    //如果是老套餐则用
                    this.user = commonUtils.getUser();
                    if (this.user.vip) { //如果不是免费用户
                        if (this.user.payLevel > 1) { //大于1为有限，如果为有限月，有限季，有限年用户
                            //计算若选择年无限应该付的金额
                            if (this.user.payType == 'Monthly') {
                                this.nowSchemeName = 'language.paySystem.limitedMonth';
                            } else if (this.user.payType == 'Quarterly') {
                                this.nowSchemeName = 'language.paySystem.twoMonthree';
                            } else {
                                //有限年套餐去掉无限年
                                this.nowSchemeName = 'language.paySystem.fourMOne';
                            }
                        } else { //如果为无限
                            if (this.user.payType == 'Monthly') { //如果为无限月
                                this.nowSchemeName = 'language.paySystem.monthlyUnlimited';
                            }
                            if (this.user.payType == 'Yearly') { //如果为无限年
                                this.nowSchemeName = 'language.paySystem.YearlyUnlimited';
                            }
                        }
                    }
                }else{
                    this.nowSchemeName = 'language.paySystem.arguments.title.'+res.nowScheme.arguments['title'];
                }
            }
        }
    }
}
</script>

<style>

#timeSaled{
    width: 1191Px;
    height: 584Px;
}

#timeLimitedSaled{
    width: 1191Px;
    height: 584Px;
}

.saled-bg-en {
    background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;
}

.saled-bg-de {
    background: url("../../../assets/images/xmasSaled-2025/bg_de.png") no-repeat;
    background-size: 100%;
}

.saled-bg-fr {
    background: url("../../../assets/images/xmasSaled-2025/bg_fr.png") no-repeat;
    background-size: 100%;
}

.saled-bg-pt {
    background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;
}

.saled-bg-it {
    background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;
}

.saled-bg-es {
    background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;
}

.saled-bg-jp {
    background: url("../../../assets/images/xmasSaled-2025/bg_jp.png") no-repeat;
    background-size: 100%;
}

.saled-bg-cn {
    background: url("../../../assets/images/xmasSaled-2025/bg_tw.png") no-repeat;
    background-size: 100%;
}

.saled-bg-tw {
    background: url("../../../assets/images/xmasSaled-2025/bg_tw.png") no-repeat;
    background-size: 100%;
}

.saled-bg-nl{
    background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;
}

.timelimited-content {
    width: 560Px !important;
    height: 520Px !important;
}

.timesale-content {
    /*background: url("../../../assets/images/xmasSaled-2025/bg_en.png") no-repeat;
    background-size: 100%;*/
    border-radius: 0;
}

.timesale-top-close {
    position: absolute;
    right: 0Px;
    top: 30Px;
    background: url("../../../assets/images/xmasSaled-2025/top_close.svg") no-repeat;
    width: 36Px;
    height: 36Px;
    z-index: 20;
}

.timesale-top-close:has(.discount_close:hover) {
    background-position: bottom;
}

/* 新年活动用 */
/* .timesale-content:has(.discount_close:hover) .discount_close-bg{
    background-position: bottom;
}

.discount_close-bg {
    z-index: -1;
    position: absolute;
    right: 0Px;
    top: 41Px;
    background: url("../../../assets/images/xmasSaled-2025/top_close.svg") no-repeat;
    width: 80Px;
    height: 80Px;
} */
/* end */

.timesale-body {
    padding-top: 160Px;
    padding-bottom: 12Px;
    border-radius: 0 0 14Px 14Px;
}

.timesale-time {
    text-align: center;
}

.timesale-time .timer-title{
    font-size: 14Px;
    font-weight: 400;
    color: #333;
    margin-top: 0Px;
}

.timer-cel {
    margin: -30Px 0 12Px;
}

.timer-describes {
    display: inline-flex;
    margin-bottom: 5Px;
}

.timer-describe {
    width: 100Px;
    font-size: 14Px;
    font-weight: 400;
    color: #B2AAFF;
}

.timesale-schemes {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    background: none;
    border-radius: 14Px
}

.timesale-scheme {
    display: inline-grid;
    text-align: center;
    width: 537Px;
    margin: 3Px 10Px 20Px 39Px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 24Px;
    z-index: 1;
}

.timesale-scheme .timesale-scheme-title{
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 60Px;
    top: 0;
    line-height: 60Px;
    /* padding-top: 26Px; */
    font-family: Arial Black;
    font-size: 24Px;
    font-weight: 900;
    background: linear-gradient(90deg, #1CBF96 0%, #048A99 100%);
    background-size: 100% 100%;
    color: #FFF6E5;
    letter-spacing: 0em;
    border-radius: 24Px 24Px 0 0;
    user-select:none
}

.timesale-scheme-un {
    z-index: 0;
    width: 537Px;
    background: #ffffff;
    color: #333;
    margin: 3Px 39Px 20Px 10Px;
}

.timesale-scheme-un .timesale-scheme-title {
    color: #FFF6E5;
    background-size: 100% 100%;
    background: linear-gradient(169deg, #FF5897 26%, #F0290A 67%);
}

#timeLimitedSaled .timesale-scheme-un {
    width: 680Px;
}

#timeLimitedSaled .timesale-scheme-un .timesale-scheme-title {
    background: linear-gradient(169deg, #FF5897 26%, #F0290A 67%);
    background-size: 100% 100%;
}

.timesale-scheme-body {
    min-height: 255Px;
    display: inline-flex;
    text-align: center;
    margin: 40Px 0 6Px;
}

.timesale-scheme-body .timesale-scheme-left,
.timesale-scheme-body .timesale-scheme-right {
    width: 50%;
    position: relative;
}

.timesale-scheme-line {
    border-right: 1Px solid rgba(255, 255, 255, 0.1);/*no*/
}

.timesale-scheme-body .scheme-title {
    height: 35Px;
    padding: 0 5Px;
    font-size: 16Px;
    font-family: Arial;
    font-weight: bold;
    color: #333;
    line-height: normal;
    letter-spacing: 0em;
}

.timesale-scheme-un .timesale-scheme-body .scheme-title {
    color: #333;
}

.timesale-scheme .scheme-discount{
    position: absolute;
    left: 20Px;
    top: -40Px;
    margin: 0;
    width: 40Px;
    height: 55Px;
    font-size: 15Px;
    font-weight: bold;
    font-family: Arial;
    letter-spacing: 0em;
    color: #fff;
    display: flex;
    align-items: center;
    /* align-items: baseline; */
    justify-content: center;
    pointer-events: none;
    line-height: 55Px;
    padding-top: 7Px;
    padding-left: 0Px;
}

.timesale-scheme .scheme-discount span{
    font-size: 8Px;
    display: block;
}

.timesale-scheme .timesale-scheme-left .scheme-discount{
    background: url("../../../assets/images/xmasSaled-2025/img-discount-1.png") no-repeat;
}

.timesale-scheme .timesale-scheme-right .scheme-discount{
    background: url("../../../assets/images/xmasSaled-2025/img-discount-1.png") no-repeat;
}

.timesale-scheme-un .timesale-scheme-left .scheme-discount{
    background: url("../../../assets/images/xmasSaled-2025/img-discount-2.png") no-repeat;
}

.timesale-scheme-un .timesale-scheme-right .scheme-discount{
    background: url("../../../assets/images/xmasSaled-2025/img-discount-2.png") no-repeat;
}

.timesale-scheme-body .scheme-price {
    text-align: center;
    margin: 10Px 0 18Px;
}

.scheme-price .price {
    font-size: 32Px;
    font-family: Arial Black;
    font-weight: 700;
    color: #048A99;
    text-align: left;
    line-height: 32Px;
    letter-spacing: 0em;
}

.timesale-scheme-un .scheme-price .price {
    color: #F0290A;
}

.scheme-price .price span{
    font-size: 24Px;
}

.scheme-price .price-old {
    font-size: 20Px;
    font-family: Arial;
    font-weight: 400;
    color: #999999;
    text-decoration: line-through;
    text-align: right;
    line-height: 5Px;
}

.timesale-scheme-body .scheme-type {
    display: none;
    font-size: 14Px;/*no*/
    font-weight: 400;
    color: #86868F;
    height: 40Px;
    line-height: 20Px;
}

.timesale-scheme-body .scheme-btn button{
    height: 36Px;/*no*/
    background: #00A7B9;
    /* border: 2px solid #000000; */
    /* box-shadow: 2px 2px 0px 0px #000000; */
    border-radius: 40Px;/*no*/
    background-size: 100%;
    font-size: 14Px;/*no*/
    font-weight: 700;
    font-family: Arial;
    color: #fff;
    min-width: 160Px;
    margin: 6Px 0;
}

.timesale-scheme-un .timesale-scheme-body .scheme-btn button{
    background: #F0290A;
    /* border: 2px solid #000000;
    box-shadow: 2px 2px 0px 0px #000000; */
}

.timesale-scheme-body .scheme-tips {
    width: fit-content;
    font-size: 12Px;
    font-family: Arial;
    font-weight: 400;
    color: #333;
    line-height: 24Px;
    display: flex;
    flex-direction: column;
    margin: 18Px auto 0;
    gap: 4Px;
}

.timesale-scheme-un .timesale-scheme-body .scheme-tips {
    color: #333;
}

.timesale-scheme-body .scheme-tips .scheme-tip{
    display: inline-flex;
}

.timesale-scheme-body .scheme-tips .point{
    height: 24Px;
    width: 10Px;
    float: left;
    background: url("../../../assets/images/saleActive/img_point_black.png") no-repeat left;
}
.timesale-scheme-un .timesale-scheme-body .scheme-tips .point{
    background: url("../../../assets/images/saleActive/img_point_black.png") no-repeat left;
}

.timesale-scheme-body .scheme-tips span{
    padding-left: 4Px;
    text-align: left;
}

.timesale-scheme-body .scheme-tips .ask{
    width: 14Px;
    height: 14Px;
    display: inline-block;
    position: relative;
    bottom: -3Px;
    left: 5Px;
    background: url("../../../assets/images/saleActive/icon_info.svg") no-repeat;
    cursor: pointer;
}

.timesale-scheme-un .timesale-scheme-body .scheme-tips .ask{
    background: url("../../../assets/images/saleActive/icon_info.svg") no-repeat;
}

.timesale-scheme-body .scheme-tips .ask:hover .plan-questionTxt {
    display: block;
}

.plan-questionTxt {
    display: none;
    position: absolute;
    max-width: 275Px;
    min-width: 250Px;
    border: 1Px solid #5562b4;
    border-radius: 3Px;
    left: 20Px;
    top: 2Px;
    
    z-index: 3;
    font-size: 12Px;
    box-sizing: border-box;
    padding: 5Px;
    line-height: 20Px;
    background: #fff;
}

.timesale-content .discount_close {
    width: 36Px;
    height: 36Px;
    margin: 0;
    cursor: pointer;
    background: none !important;
}

.timesale-footer{
    display: none;
    text-align: center;
    font-size: 16Px;
    font-family: Arial;
    font-weight: bold;
    color: #F3BF79;
    line-height: 17Px;
    letter-spacing: 0em;
    opacity: 1;
    position: absolute;
    width: 100%;
    bottom: 30px;
}

/* 72小时弹窗 */
.mainPart .special-table .explain-tip {
    text-align: left;
    color: #B1ABA7;
    line-height: 15Px;
    display: table-row;
}
.mainPart .special-table .explain {
    margin-left: 5Px;
    cursor: pointer;
}
.mainPart .msgContent .special-table .no_style {
    text-align: left;
    font-size: 12Px;
}

.mainPart .msgContent .special-table {
    line-height: 25Px;
    text-align: center;
}

.msgContent .upgrade-table {
    width: 100%;
}

.msgContent {
    float: left;
    border-radius: 4Px;
    background-color: #fff;
    padding: 1%;
    margin: 0 1.5%;
    width: 95%;
    font-size: 12Px;
}

.mainPart .special-msgContent {
    height: 205Px;
}

.mainPart .c-top-right .c-price-describe {
    background-color: #fff;
    height: 30Px;
    width: 350Px;
    line-height: 30Px;
    font-size: 15Px;
    margin-left: -45Px;
    border-radius: 30Px;
    text-align: center;
}

.mainPart .c-unlimit-btn {
    background-color: #FFF600 !important;
    color: #000 !important;
    margin: 20Px 0 !important;
    width: 180Px !important;
}

.mainPart .c-right-footer {
    padding: 10Px 0;
    float: left;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
}
.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}
.special-msgContent .el-scrollbar__bar.is-vertical{
    right: 0Px !important;
}
.special-msgContent .el-scrollbar__thumb {
    background-color: #DCDCDC !important;

}
.special-msgContent .el-scrollbar__bar.is-vertical {
    width: 6px !important;
    /*no*/

}
#countdownTime {
    display: inline-flex;
}

.mainPart{
    padding: 0Px 13Px;
    font-size: 13Px;
    margin-top: -20Px;
}
.discountPart {
    padding: 0Px;
}
.mainPart .main_title {
    text-align: center;
    color: #fff;
    line-height: 35Px;
    font-size: 15Px;
    width: 500Px;
    margin: 0 auto;
}
.mainPart .main_title h6 {
    -webkit-text-stroke: 1Px #fff;
    color: #FF4B20;
    font-size: 20Px;
    font-weight: 800;
    margin: 0;
}
.discountPart .main_title span {
    border-radius: 3Px;
    background: #F64112;
    padding: 2Px 5Px;
    color: #fff;
}
.mainPart .c-top-right {
    color: #544B46;
    text-align: center;
    width: 238Px;
    margin: 5Px auto;
}
.mainPart .timer-describe-old span {
    width: 65Px;
    display: block;
    float: left;
    margin: 5Px 6Px 0Px 8Px;
    color: #fff;
}

.mainPart #remainTime div{
   height: 36Px;
   width: 5Px;
   float: left;
   line-height: 36Px;
   font-weight: 600;
   color: #fff;
}

.mainPart #countdownTime div{
   height: 36Px;
   width: 5Px;
   float: left;
   line-height: 36Px;
   font-weight: 600;
   color: #fff;
}

.discountPart .msgContent .upgrade-table .first_tr {
    border: 0Px;
}
.discountPart .msgContent .upgrade-table .first_tr td {
    color: #614738;
    font-size: 13Px;
    font-weight: normal;
    min-width: 100Px;
}
.discountPart .msgContent .upgrade-table td {
    text-align: left;
}
.discountPart .msgContent .upgrade-table .last_td {
    text-align: center;
}
.upgrade-table tr .tips {
    display: inline-block;
    border: 1Px solid orange;
    background: #f9ddc2;
    color: #a69494;
    line-height: 15Px;
    width: 200Px;
    border-radius: 4Px;
    padding: 2Px 5Px 2Px 5Px;
    text-align: left;
    position: absolute;
    z-index: 999;
    margin-top: 15Px;

}
.ask{
    cursor: pointer;
}

.upgrade-table .first_td {
    font-weight: 600;
}

.discountPart .msgContent .upgrade-table tr {
    font-size: 14Px;
    line-height: 25Px;
}
.mainPart .msgContent .upgrade-table tr {
    border-top: 1Px solid #F5F7FA;

}
.discountPart .msgContent .upgrade-table .now_price {
    text-decoration: line-through;
    color: #BEBEBE;
}

.mainPart .c-top-btn {
    float: right;
    width: 120Px;
    height: 35Px;
    border-style: none;
    outline: none;
    background-color: #FF8500;
    color: #fff;
    cursor: pointer;
    font-weight: 600;
    border-radius: 3Px;
    margin-top: 50Px;
    font-size: 13Px;
}
.upgrade-table .c-td-btn {
    height: 37Px;
    float: none;
    min-width: 90Px;
    margin: 6Px 0;
    line-height: 16Px;
}
.discountPart .upgrade-table .c-td-btn {
    color: #fff;
    background-color: #FF8500;
    height: 30Px;
}
.discountPart .msgContent .upgrade-table .dis_price {
    color: #FF8500;
    font-weight: 600;
}


 @keyframes boutime-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(0.6, 0.8);
    }

    100% {
        transform: scale(0.8, 1);
    }

    font {
        transform: scale(1, 1);
    }
}

.boutime-enter-active {
    transform-origin: 76% 10%;
}

.boutime-leave-active {
    transform-origin: 151% -30%;
    animation: boutime-in 0.8s reverse;

}
.special-msgContent::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 5Px;
    /*no*/
    background-color: #fff;
}

.special-msgContent::-webkit-scrollbar-thumb {
    border-radius: 5Px;
    /*no*/
    background-color: #DCDCDC;
}

#timeSaledPopup .time-box{
    background: linear-gradient(180deg, #464646 0%,#000000 50%,#464646 50%, #000000 100%);
    color: #FFFFFF;
}

#timeSaledPopup .time-box .face,#timeSaledPopup .time-box .base-b,#timeSaledPopup .time-box .back{
    background: linear-gradient(180deg, #464646 0%,#000000 50%,#464646 50%, #000000 100%);
}

.title-other-img {
    position: absolute;
    pointer-events: none;
    user-select: none;
}

.temp {
    position: absolute;
    z-index: 10;
    left: 526Px;
    pointer-events: none;
}

.vip-upgrade-tips {
    line-height: 20px;
    height: 20px;
    margin-bottom: 6px;
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    color: #333;
}

.timesale-scheme-un .vip-upgrade-tips{
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/flash_saled_popup.vue